export default {
      id: "icon-twitter-usage",
      viewBox: "0 0 51.864 41.491",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-twitter",
      toString: function () {
        return this.url;
      }
    }